module.exports = __webpack_public_path__ + "static/media/benequer.8145e99d.png";